import SchoolsService from "services/SchoolsService";

const { createAsyncThunk, createSlice } = require("@reduxjs/toolkit");

export const getSchools = createAsyncThunk(
    "schools/getAll",
    async (id, { rejectWithValue }) => {
        try {
            const response = await SchoolsService.getSchools(id);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response || "Erreur");
        }
    }
);

export const getAllSchools = createAsyncThunk(
    "schools/getAllSchools",
    async (id, { rejectWithValue }) => {
        try {
            const response = await SchoolsService.getAllSchools();
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response || "Erreur");
        }
    }
);

export const getSchoolById = createAsyncThunk(
    "schools/getSchoolById",
    async ({ userId, schoolId }, { rejectWithValue }) => {
        try {
            const response = await SchoolsService.getSchoolById(
                userId,
                schoolId
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response || "Erreur");
        }
    }
);

export const createSchool = createAsyncThunk(
    "schools/createSchool",
    async ({ adminSchoolId, data }, { rejectWithValue }) => {
        try {
            const response = await SchoolsService.createSchool(
                adminSchoolId,
                data
            );
            return response.data.school;
        } catch (error) {
            return rejectWithValue(error.response.data.error || "Erreur");
        }
    }
);

export const updateSchoolById = createAsyncThunk(
    "schools/updateSchoolById",
    async ({ adminSchoolId, schoolId, data }, { rejectWithValue }) => {
        try {
            const response = await SchoolsService.updateSchool(
                adminSchoolId,
                schoolId,
                data
            );
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Erreur");
        }
    }
);

export const deleteSchoolById = createAsyncThunk(
    "schools/deleteSchoolById",
    async ({schoolId,adminSchoolId}, { rejectWithValue }) => {
        try {
            // TODO: this is supposed to return the deleted school id, but the API returns only a status message
            
            
            await SchoolsService.deleteSchoolById(adminSchoolId,schoolId);
            return schoolId;
        } catch (error) {
            return rejectWithValue(error.response || "Erreur");
        }
    }
);

const initialState = {
    schools: [],
    school: null,
    loading: false,
    error: null,
    allSchools: [],
};

const schoolsSlice = createSlice({
    name: "schools",
    initialState,
    reducers: {
        setSchools: (state, { payload }) => {
            state.schools = payload;
        },
        setSchool: (state, { payload }) => {
            state.school = payload;
        },
        setLoading: (state, { payload }) => {
            state.loading = payload;
        },
        setError: (state, { payload }) => {
            state.error = payload;
        },
    },
    extraReducers: {
        [getSchools.pending]: (state) => {
            state.loading = true;
        },
        [getSchools.fulfilled]: (state, { payload }) => {
            state.schools = payload;
            state.loading = false;
        },
        [getSchools.rejected]: (state, { payload }) => {
            state.error = payload;
            state.loading = false;
        },
        [getSchoolById.pending]: (state) => {
            state.loading = true;
        },
        [getSchoolById.fulfilled]: (state, { payload }) => {
            state.school = payload;
            state.loading = false;
        },
        [getSchoolById.rejected]: (state, { payload }) => {
            state.loading = false;
        },
        [getAllSchools.pending]: (state) => {
            state.loading = true;
        },
        [getAllSchools.fulfilled]: (state, { payload }) => {
            state.allSchools = payload;
            state.loading = false;
        },
        [getAllSchools.rejected]: (state, { payload }) => {
            state.error = payload;
            state.loading = false;
        },
        [createSchool.pending]: (state, { payload }) => {
            state.loading = true;
        },
        [createSchool.fulfilled]: (state, { payload }) => {
            state.schools.push(payload);
            state.loading = false;
        },
        [createSchool.rejected]: (state, { payload }) => {
            state.loading = false;
        },
        [updateSchoolById.pending]: (state) => {
            state.loading = true;
        },
        [updateSchoolById.fulfilled]: (state, { payload }) => {
            state.schools = state.schools.map((school) =>
                school._id === payload._id ? payload : school
            );
            state.loading = false;
        },
        [updateSchoolById.rejected]: (state, { payload }) => {
            state.loading = false;
        },
        [deleteSchoolById.pending]: (state) => {
            state.loading = true;
        },
        [deleteSchoolById.fulfilled]: (state, { payload }) => {
            state.schools = state.schools.filter(
                (school) => school._id !== payload
            );
            state.loading = false;
        },
        [deleteSchoolById.rejected]: (state, { payload }) => {
            state.loading = false;
        },
        
    },
});

export const { setSchools, setSchool, setLoading, setError } =
    schoolsSlice.actions;

export default schoolsSlice.reducer;
